// app/components/Plugins/Automations/nodes/StatusNode.tsx
'use client'

import React from 'react'
import { Handle, Position } from '@xyflow/react'
import { StatusNodeData, NodeProps } from '../types'

const StatusNode: React.FC<NodeProps<StatusNodeData>> = ({ data, isConnectable }) => {
  // Map status to color
  const getStatusColor = () => {
    switch (data.status) {
      case 'IN_PROGRESS':
        return '#ffa726' // Orange
      case 'COMPLETED':
        return '#66bb6a' // Green
      case 'ERROR':
        return '#ef5350' // Red
      default:
        return '#78909c' // Blue-grey (IDLE)
    }
  }
  
  return (
    <div className="node statusNode">
      <div className="node-header">Status</div>
      <div className="node-content">
        <div 
          className="status-indicator"
          style={{
            backgroundColor: getStatusColor(),
            padding: '8px 12px',
            borderRadius: '4px',
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#fff'
          }}
        >
          {data.status}
        </div>
      </div>
      
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="in"
        isConnectable={isConnectable}
      />
    </div>
  )
}

export default StatusNode